import React from 'react'
import ModalCustom from '../../../component/modalCustom/modalCustom';
import {
    Card,
    CardContent,
    Typography,
    List,
    ListItem,
    ListItemText,
    Divider,
    Chip,
    Box,
} from "@mui/material";
import moment from 'moment';
import { STATUS_TRANFER, status_transfer_data } from '../../stall/stall-agreement/enum/enum';

type Props = {
    title: string;
    onClose?: () => void;
    data: {
        title: string;
        remark: string;
        status: string;
        date_log: string | Date;
    }[]
}

const HistoryTransfer: React.FC<Props> = ({ data, title, onClose }: Props) => {
    // const mock_data = [
    //     {
    //         title: "V2N Developer",
    //         remark: "ผู้สืบทอดไม่ตรงกับในสัญญา",
    //     },
    //     {
    //         title: "V2N Developer",
    //         remark: "ผู้สืบทอดไม่ตรงกับในสัญญา ครั้งที่ 2",
    //     },
    // ]
    return (
        <ModalCustom
            title={title}
            size='xl'
            isShowProps
            onClose={onClose}
            closeButton
            component={
                <div className='w-100'>
                    <Card elevation={3} sx={{ borderRadius: 3 }}>
                        <CardContent>
                            <Typography variant="h6" fontWeight="bold" gutterBottom>
                                รายการทบทวน
                            </Typography>

                            <List>
                                {data?.length === 0 && (
                                    <Typography>ไม่พบรายการ...</Typography>
                                )}
                                {data?.map((item, index) => {
                                    const status_label = status_transfer_data?.find((x) => x.value == item.status)?.label ?? "";
                                    return (
                                        <React.Fragment key={index}>
                                            <ListItem alignItems="flex-start">
                                                <ListItemText
                                                    primary={
                                                        <Box display="flex" alignItems="center" gap={1}>
                                                            {/* <Typography fontWeight={600}>
                                                                รายการที่ {index + 1}
                                                            </Typography> */}
                                                            {item.date_log && (
                                                                <Chip
                                                                    label={`เมื่อวันที่ ${moment(item.date_log).add(543, 'year').format("DD-MM-YYYY")}`}
                                                                    size="small"
                                                                    color={"default"}
                                                                    variant="outlined"
                                                                />
                                                            )}
                                                            {status_label && (
                                                                <Chip
                                                                    label={status_transfer_data?.find((x) => x.value == item.status)?.label ?? ""}
                                                                    size="small"
                                                                    color={item.status == STATUS_TRANFER.REVIEW ? "info" : item.status == STATUS_TRANFER.NOT_APPROVE ? "error" : "warning"}
                                                                    variant="outlined"
                                                                />
                                                            )}
                                                        </Box>
                                                    }
                                                    secondary={
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            sx={{ mt: 0.5 }}
                                                        >
                                                            {item.remark}
                                                        </Typography>
                                                    }
                                                />
                                            </ListItem>

                                            {index !== data.length - 1 && <Divider />}
                                        </React.Fragment>
                                    )
                                })}
                            </List>
                        </CardContent>
                    </Card>
                </div>
            }


        />
    )
}

export default HistoryTransfer